import styled from "styled-components";

export const Table = styled.table`
  overflow-x: auto;
  text-align: start;
  border-collapse: separate;
  border-spacing: 0 0.35rem;
  width: 100%;
  max-width: 90vw;
  padding-right: 4vw;
  padding-left: 4vw;
  margin: 0 auto;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.7vw;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.7vw;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.7vw;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.7vw;
  }

  @media (max-width: 1024px) {
    font-size: 14px;
  }
`

export const HeaderRow = styled.tr`
  position: sticky;
  top: 0;
  height: 2.2rem;
`

export const ItemRow = styled.tr`
  height: 2.4rem;
  background-color: #fff;

  &:hover{
    background-color:#F7F7F7;
    
    .edit-div{
      visibility:visible;
    }
  }
`
export const StatusText = styled.span`
  display: flex;
  justify-content: center;
  padding: .2rem .5rem;
  border-radius: 2rem;
  font-size: 10px;
  display: flex;
  align-items: center;
  gap: .5rem;
  font-weight: 400;
  user-select: none;
  background-color: #c2c2c2;
  color: #464543;
  width: fit-content;

  &.completed{
    color: #67C97E;
    background-color:rgba(179, 228, 191, 0.3);
  }
 
  &.pending{
    background-color: #FFFCEE;
    color: #9D7D07;
  }

  &.cancel{
    background-color:rgba(245, 142, 142, 0.3);
    color: #9d1e07;
  }

`

export const ContainerScroll = styled.div`

  border-radius: 0.3rem;
  height: 40rem;
  background-color: #e1e1e1;
  padding: 0.5rem;
  margin-top: 15px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffffff; /* Cor do thumb do scrollbar */
    border-radius: 3px; /* Border radius do thumb */
  }

  &::-webkit-scrollbar-track {
    background: #c0c0c0; /* Cor de fundo do scrollbar */
    border-radius: 3px; /* Border radius do track */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555555; /* Cor do thumb ao passar o mouse por cima */
  }
`
export const HeaderCell = styled.th`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: 14px;
  padding-left: 2vw;
  padding: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`

export const ItemCell = styled.td`
  width: 15vw;
  text-align: start;
  font-size: 14px;
  padding-left: 2vw;
  border-bottom: solid 1px #ebebeb;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const ItemCellContainer = styled.div`
  display:flex;
  gap:0.3vw;
  align-items:center;

  .documentUrl {
    cursor:pointer;
    &:hover {
    color: #0090d3;
    }
  }
`


export const ImageCell = styled.td`
  z-index: 0;
  width: 5vw;
  text-align: start;
  font-size: 14px;
  padding-left: 1vw;
  border-bottom: solid 1px #EBEBEB;
  word-wrap: break-word;
  overflow-wrap: break-word;
`
export const OptionsImage = styled.img`
  cursor: pointer;
  z-index: 0;
  padding-left: 1.5rem;
`

export const EditDiv = styled.div`
  height: 1.5rem;
  width: 1.5rem;
  background-color: #ededed;
  border: 1px solid #848484;
  display:flex;
  justify-content:center;
  align-items:center;
  border-radius: 25%;
  filter:grayscale(1);
  visibility:hidden;
  
  &:hover{
    background-color:#fff;
    border: 1px solid #0090D3;
    filter:grayscale(0);
  }
`